import React, { Component, Fragment } from 'react';
import { Form } from 'reactstrap';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import { createFormField } from '../../../models/FormField';
import FormValidator from '../../../services/FormValidator';
import { createForm } from '../../../models/Form';
import BalanceUser from '../../../models/BalanceUser';
import QuantityFieldGroup from '../../common/QuantityFieldGroup';
import { productCountValid, quantityValid } from '../../../util/formValidators';
import FieldError from '../../form/FieldError';
import globalTranslations from '../../../i18n/globalTranslations';

const DEFAULT_VALUE = 0;

@observer
export class BalanceForm extends Component {
  form = null;

  formName = 'BalanceForm';

  constructor(props) {
    super(props);
    const { user, maxQuantity, quantityStep, incrementStep } = this.props;
    let formFields = {};

    const quantityFieldName = `quantity-${user.id}`;

    formFields[quantityFieldName] = createFormField(
      { value: user && user.account_balance },
      [
        quantityValid(maxQuantity, quantityStep),
        // We use incrementStep prop here so we can have zero value as a valid quantity.
        productCountValid(
          incrementStep,
          globalTranslations.balanceUserBalanceValidationError
        )
      ]
    );

    this.form = createForm(formFields);
  }

  handleSubmit = (e) => {
    const { onSubmit } = this.props;
    e.preventDefault();
    this.form.validate();

    if (this.form.valid) {
      onSubmit();
    }
  };

  onBalanceUpdate = (value) => {
    const { user, onBalanceError } = this.props;
    this.form.validate();
    if (this.form.valid) {
      this.props.onBalanceUpdate(user.id, value, user);
    }

    onBalanceError &&
      onBalanceError(user.id, this.form.fields.get(`quantity-${user.id}`));
  };

  render() {
    const {
      user,
      maxQuantity,
      quantityStep,
      defaultValue,
      incrementStep
    } = this.props;

    const quantityField = this.form.fields.get(`quantity-${user.id}`);
    quantityField.setValue(defaultValue);
    this.form.validate();

    return (
      <Fragment>
        <div className="BalanceForm">
          <Form
            className={this.formName}
            noValidate
            onSubmit={this.handleSubmit}
          >
            <QuantityFieldGroup
              key={user.id}
              className="BalanceForm__quantity-group"
              field={quantityField}
              maxQuantity={maxQuantity}
              quantityStep={quantityStep}
              incrementStep={incrementStep}
              defaultValue={DEFAULT_VALUE}
              unit={user.account_currency}
              onUpdateProductQuantity={this.onBalanceUpdate}
              balanceUserAccount={true}
            />
          </Form>
        </div>
        <FieldError field={quantityField} />
      </Fragment>
    );
  }
}

BalanceForm.propTypes = {
  maxQuantity: PropTypes.number.isRequired,
  quantityStep: PropTypes.number.isRequired,
  incrementStep: PropTypes.number.isRequired,
  formValidator: PropTypes.instanceOf(FormValidator).isRequired,
  loading: PropTypes.bool,
  user: modelOf(BalanceUser),
  onSubmit: PropTypes.func.isRequired,
  onBalanceUpdate: PropTypes.func,
  defaultValue: PropTypes.string,
  onBalanceError: PropTypes.func
};

export default inject('formValidator')(BalanceForm);



// WEBPACK FOOTER //
// ./src/components/user/BalanceForm/index.jsx